<template>
  <section class="ctn">
    <heim-card>
      <header>
        <h1>{{ $t('setup') }}</h1>
      </header>
      <main>
        <form @submit.prevent="handleForm">
          <div class="row">
            <span class="label">MoniThor</span>
            <div class="inputs">
              <heim-input
                type="text"
                :label="$t('domain')"
                name="domain"
                placeholder="https://..."
                :value="domain"
              ></heim-input>
              <heim-input type="text" :label="$t('port')" name="port" placeholder="8080" :value="port" icon></heim-input>
            </div>
          </div>
          <div class="row">
            <span class="label">{{ $t('dashboard') }}</span>
            <div class="inputs">
              <heim-input
                type="text"
                :label="$t('dashboardRefresh')"
                name="refresh"
                placeholder="60000"
                :value="refresh"
              ></heim-input>
            </div>
          </div>
          <footer class="actions">
            <heim-button type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
  </section>
</template>

<script>
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import { mapState } from "vuex";
export default {
  name: "Setup",
  components: {
    HeimInput,
    HeimButton,
    HeimCard
  },
  mounted() {
    this.$store.dispatch("setTitle", "Setup");
  },
  methods: {
    handleForm(e) {
      this.$store.dispatch("setupMonithor", {
        domain: e.target.domain.value,
        port: e.target.port.value,
        refresh: e.target.refresh.value
      });
      this.$store.dispatch("setToastMessage", { message: "configSaved" });
      this.$store.dispatch("setToastMode", {});
      this.$store.dispatch("setOpenToast", { opened: true });
      window.location.reload();
    }
  },
  computed: {
    ...mapState(["domain", "port", "refresh"])
  }
};
</script>

<style scoped>
</style>
